import React from 'react'
import { Flipper, Flipped, spring } from 'react-flip-toolkit'

import Donation from './Donation'

const Donations = ({ orders }) =>
  orders.length
  ? <Flipper
      flipKey={orders.map(o => o.id).join()}
      element="ul"
      className="list-group list-group-flush"
    >
      {
        orders.map(order =>
          <Flipped
            key={order.id}
            flipId={order.id.toString()}
            onAppear={(el, index) => {
              spring({
                config: { overshootClamping: true },
                values: { opacity: [ 0, 1 ] },
                onUpdate: ({ opacity }) => el.style.opacity = opacity,
              })
            }}
            onExit={(el, index, removeElement) => {
              spring({
                config: { overshootClamping: true },
                values: { opacity: [ 1, 0 ] },
                onUpdate: ({ opacity }) => el.style.opacity = opacity,
                onComplete: removeElement,
              })
            }}
          >
            <li className="list-group-item py-4">
              <Donation order={order} />
            </li>
          </Flipped>
        )
      }
    </Flipper>
  : <div className="list-group list-group-flush">
      <div className="list-group-item py-4">
        There are currently no donations.
      </div>
    </div>

export default Donations
